import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import fetchWrapper from '../utils/httpClient';
import {
  API_GET_INDUSTRY_PRODUCTS,
  API_UPDATE_INDUSTRY_PRODUCTS
} from '../utils/apis';

export const fetchIndustryProducts = createAsyncThunk(
  'packageIndustry/fetchIndustryProducts',
  async ({ language, region = 'SG', ...otherParams } = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams({
        language,
        region,
        ...otherParams
      }).toString();

      const url = `${API_GET_INDUSTRY_PRODUCTS}?${queryParams}`;
      const response = await fetchWrapper.get(url);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch industry products');
    }
  }
);

export const updateIndustryProducts = createAsyncThunk(
  'packageIndustry/updateIndustryProducts',
  async ({ requestBody, region = 'SG' } = {}, { rejectWithValue }) => {
    try {
      const response = await fetchWrapper.post(API_UPDATE_INDUSTRY_PRODUCTS, {
        ...requestBody,
        region
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update industry products');
    }
  }
);

const packageIndustrySlice = createSlice({
  name: 'packageIndustry',
  initialState: {
    industryProducts: null,
    productsLoading: false,
    productsError: null,

    updateLoading: false,
    updateError: null,
    updateSuccess: false,

    currentLanguage: '',
  },
  reducers: {
    clearIndustryError: (state) => {
      state.productsError = null;
      state.updateError = null;
    },
    clearIndustryProducts: (state) => {
      state.industryProducts = null;
    },
    clearUpdateStatus: (state) => {
      state.updateLoading = false;
      state.updateError = null;
      state.updateSuccess = false;
    },
    setIndustryLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
    clearAllIndustryState: (state) => {
      state.industryProducts = null;
      state.productsLoading = false;
      state.productsError = null;
      state.updateLoading = false;
      state.updateError = null;
      state.updateSuccess = false;
      state.currentLanguage = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIndustryProducts.pending, (state) => {
        state.productsLoading = true;
        state.productsError = null;
      })
      .addCase(fetchIndustryProducts.fulfilled, (state, action) => {
        state.productsLoading = false;
        state.industryProducts = action.payload;
      })
      .addCase(fetchIndustryProducts.rejected, (state, action) => {
        state.productsLoading = false;
        state.productsError = action.payload;
      })
      .addCase(updateIndustryProducts.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
        state.updateSuccess = false;
      })
      .addCase(updateIndustryProducts.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = true;
      })
      .addCase(updateIndustryProducts.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
        state.updateSuccess = false;
      });
  }
});

export const {
  clearIndustryError,
  clearIndustryProducts,
  clearUpdateStatus,
  setIndustryLanguage,
  clearAllIndustryState
} = packageIndustrySlice.actions;

export default packageIndustrySlice.reducer;